import React, { Component } from 'react';
import FileStackImage from 'misc/filestack_image';

const COVER_WIDTH = 128;
const COVER_HEIGHT = 248;

class CoverImage extends Component {
  constructor(props) {
    super(props);
    this.image = props.image?.bssUploadId
      ? {
          ...props.image,
          url: `'${props.image.bssSignedUrl}'`,
          name: props.image.fileName,
        }
      : this.setFileStackImage(props.image);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      handle: nextHandle,
      bssUploadId: nextBssUploadId,
      fileName: nextFileName,
      bssSignedUrl: nextBssSignedUrl,
    } = nextProps.image;

    const { handle: currentHandle, bssUploadId: currentBssUploadId } =
      this.props.image;

    if (nextBssUploadId && nextBssUploadId !== currentBssUploadId) {
      this.image = {
        ...nextProps.image,
        url: nextBssSignedUrl,
        name: nextFileName,
      };
    } else if (nextHandle && nextHandle !== currentHandle) {
      const { image } = nextProps;
      if (!this.image.updateParams) {
        this.image = this.setFileStackImage(image);
      } else {
        this.image.updateParams(image);
      }
    }
  }

  setFileStackImage(image) {
    return new FileStackImage({
      ...image,
      transform: {
        resize: {
          fit: 'crop',
          align: 'center',
          width: COVER_WIDTH * 2,
          height: COVER_HEIGHT * 2,
        },
      },
    });
  }

  render() {
    return (
      <div className="LibraryTopic-imageContainer">
        <div
          className="LibraryTopic-image"
          style={{
            backgroundImage: `url(${this.image.url})`,
          }}
        />
      </div>
    );
  }
}

export default CoverImage;
